export const MY_REFERRAL_PAGE = '/me/referrals';
